// removed by extract-text-webpack-plugin
module.exports = {"descriptionList":"antd-pro-descriptionList","title":"antd-pro-title","term":"antd-pro-term","detail":"antd-pro-detail","vertical":"antd-pro-vertical","descriptionListSmall":"antd-pro-descriptionListSmall","descriptionListLarge":"antd-pro-descriptionListLarge"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/DescriptionList/index.less
// module id = 184
// module chunks = 0 1